module.exports = __webpack_public_path__ + "static/img/fish20.39ce7da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish20.png
// module id = PDge
// module chunks = 0